import { createContext, useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addBusiness, getBusinesses, updateBusiness } from "../firebase/controller/community";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import { closeModal, openModal } from "../redux/modal/modalRedux";
import { useEffect } from "react";
import { getAuth } from "firebase/auth";

const BusinessContext = createContext();

export function useBusiness() {
    return useContext(BusinessContext);
}

export function BusinessProvider ({ children }) {

    const { user } = useSelector((state) => state.authStore);
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const [businesses, setBusinesses] = useState([]);
    const [mybusinesses, setMyBusinesses] = useState([]);
    const [ loadMyBusinesses, setLoadMyBusinesses ] = useState(false);

    const [selectedBusiness, setSelectedBusiness] = useState(null);

    const dispatch = useDispatch();

    const getbusinesses = async () => {
        try {
            setLoading(true);
            const res = await getBusinesses(businesses.length - 1, false);
            setBusinesses([...businesses, ...res]);
            setLoading(false);
        } catch (error) {
            const message = error.message;
            toast.error(message);
            console.log(message);
            setLoading(false);
        }
    }

    const getmybusinesses = async () => {
        try {
            setLoading(true);
            const res = await getBusinesses(mybusinesses.length - 1 ,true);
            setMyBusinesses([...mybusinesses, ...res]);
            setLoading(false);
        } catch (error) {
            const message = error.message;
            toast.error(message);
            console.log(message);
            setLoading(false);
        }
    }

    const loadMoreBusinesses = async () => {
        try {
            if (!isEmpty(user)) {
                setLoading(true);
                const res = await getBusinesses(businesses.length - 1, setLoadMyBusinesses);
                setBusinesses([...businesses, ...res]);
                setLoading(false);
            }
        } catch (error) {
            const message = error.message;
            toast.error(message);
            setLoading(false);
        }
    }

    const createBusiness = async (data) => {
        try{
            const res = await addBusiness({ ...data });
            res && toast.success("business created successful.");
            setDone(true);
            window.location.reload();
            setLoading(false);
        } catch (error) {
            const message = error.message;
            toast.error(message);
            setLoading(false);
        }
    }

    const updatebusiness = async (data, businessId) => {
        try {
            const res = await updateBusiness({ ...data }, businessId);
            res && toast.success("business created successfully.");
            setSelectedBusiness(null)
            setDone(true);
            setLoading(false);
        } catch (error) {
            const message = error.message;
            toast.error(message);
            setLoading(false);
        }
    }
    
    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged((user) => {
            if (user) {
                if (!loadMyBusinesses) getbusinesses();
                if (loadMyBusinesses) getmybusinesses();
            }
        });
        return unsubscribe;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadMyBusinesses]);


    useEffect(() => {
        if (loading) dispatch(openModal())
        if (!loading) dispatch(closeModal())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, setLoading])

    const value = {
        businesses,
        mybusinesses,
        setLoadMyBusinesses,
        loadMyBusinesses,
        loadMoreBusinesses,
        updatebusiness,
        createBusiness,
        setSelectedBusiness,
        selectedBusiness,
        setLoading,
        done,
    }
    return <BusinessContext.Provider value={value}>
        {children}
    </BusinessContext.Provider>
}